import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const useVoteComponentStyle = createStyles(() => ({
  optionContainer: {},

  option: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
  },

  blurComponentContainer: {
    position: 'relative',
  },

  blurComponentBackground: {
    position: 'absolute',
    width: '100%',
    height: '200%',
    top: '-20px',
    backdropFilter: 'blur(7px)',
    WebkitBackdropFilter: 'blur(7px)',
  },

  blurComponentOptionContainer: {
    display: 'flex',
    margin: '60px 20px',
    color: themeVariables.fontColors.medium,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    borderRadius: '16px',
    overflow: 'hidden',
  },

  normalComponentContainer: {
    display: 'flex',
    margin: '60px 20px',
    color: themeVariables.fontColors.medium,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    borderRadius: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
  },

  resultComponentContainer: {
    display: 'flex',
    margin: '60px 20px',
    color: themeVariables.fontColors.medium,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    borderRadius: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
  },
}));

export const createDiscussionDetailPageStyles = createStyles((theme) => ({
  cardContainer: {
    padding: 18,
    [theme.fn.smallerThan('sm')]: {
      padding: 0,
    },
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.05em',
    columnGap: 16,
  },

  desktopShareButtonsContainer: {
    marginLeft: 'auto',
  },

  mobileShareButtonsContainer: {
    display: 'flex',
    margin: '60px 0px 20px',
  },

  mobileShareButtonsBackground: {
    margin: 'auto',
    backgroundColor: themeVariables.colors.light000,
    padding: 8,
    borderRadius: 30,
  },

  headerBoldTile: {
    fontSize: 32,
    fontWeight: 700,
    color: themeVariables.fontColors.dark,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 27,
    },
  },

  headerTitle: {
    fontSize: 27,
    fontWeight: 400,
    margin: '12px 0px',
    color: themeVariables.fontColors.dark,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 24,
    },
  },

  bodyContainer: {
    margin: '60px 0px 90px',
  },

  bodyVoteTitle: {
    fontSize: 16,
    padding: 10,
    fontWeight: 600,
    letterSpacing: '-0.05em',
    color: themeVariables.fontColors.dark,
  },

  commentContainer: {
    ':hover': {
      cursor: 'pointer',
    },
  },

  commentTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: themeVariables.fontColors.extraDark,
  },


  addCommentTitle: {
    fontSize: 16,
    fontWeight: 600,
    padding: '20px 0px',
    color: themeVariables.fontColors.extraDark,
  },

  addCommentButtonContainer: {
    textAlign: 'end',
    margin: '8px 0px',
  },
}));
